import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

   /**
   * Returns the public key.
   * 
   * @param publicKey - public key coming from the back end.
   */
    getPublicKey(publicKey) {
       return Forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----${(publicKey)}-----END PUBLIC KEY-----`);
    }

  /**
   * Returns the encrypted password.
   * 
   * @param password - password of the login form.
   */
  getCipherText(password: string, publickKey): string {
    const passwordCiphertext = publickKey.encrypt(password, 'RSA-OAEP', {
      md: Forge.md.sha256.create()
    });
    return Forge.util.encode64(passwordCiphertext)
  }
}
